import React from 'react'
import ReactDOM from 'react-dom'
import {
  EditCustomerModal,
  EditCustomerModalProps,
} from '@vend/business-components'
import { reactular } from '@vendhq/reactular'

const EditCustomerModalWrapper: React.FC<{
  options: EditCustomerModalProps
}> = ({ options }) => {
  return ReactDOM.createPortal(
    <EditCustomerModal {...options} />,
    document.body
  )
}

export const reactEditCustomerModal = reactular(
  EditCustomerModalWrapper,
  ['options'],
  'reactWrapper'
)
